"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("./context");
exports.passThruVert = `
#ifdef GL_ES
precision mediump float;
precision mediump int;
precision mediump sampler2D;
#endif

attribute vec3 a_position;

void main() {
  gl_Position = vec4(a_position, 1.0);
}`;
exports.passThruFrag = `
#ifdef GL_ES
precision mediump float;
precision mediump int;
precision mediump sampler2D;
#endif

uniform sampler2D u_tex;
uniform float u_textureWidth;

void main() {
  gl_FragColor = texture2D(u_tex, gl_FragCoord.xy / u_textureWidth);
}`;
class ComputeShader {
    constructor(fs, vars, vs, ctx) {
        ctx = (ctx ? context_1.setWebGLContext(ctx) : context_1.getWebGLContext());
        this.vertShader = this.createVertShader(this.searchAndReplace(vs ? vs : exports.passThruVert, vars));
        this.fragShader = this.createFragShader(this.searchAndReplace(fs, vars));
        this.program = this.createProgram(this.vertShader, this.fragShader);
        this.attributeInfo = this.getAttributeInfo(ctx, this.program);
        this.uniformInfo = this.getUniformInfo(ctx, this.program);
    }
    delete() {
        const gl = context_1.getWebGLContext();
        gl.deleteShader(this.vertShader);
        gl.deleteShader(this.fragShader);
        gl.deleteProgram(this.program);
    }
    createVertShader(source) {
        const gl = context_1.getWebGLContext();
        const vertShader = gl.createShader(gl.VERTEX_SHADER);
        if (!vertShader)
            throw new Error("unable to create new vertex shader");
        gl.shaderSource(vertShader, source.trim());
        gl.compileShader(vertShader);
        if (!gl.getShaderParameter(vertShader, gl.COMPILE_STATUS))
            throw new Error(`could not compile vertex shader: ${gl.getShaderInfoLog(vertShader)}\n\n${source.trim()}`);
        return vertShader;
    }
    createFragShader(source) {
        const gl = context_1.getWebGLContext();
        const fragShader = gl.createShader(gl.FRAGMENT_SHADER);
        if (!fragShader)
            throw new Error("unable to create new fragment shader");
        gl.shaderSource(fragShader, source.trim());
        gl.compileShader(fragShader);
        if (!gl.getShaderParameter(fragShader, gl.COMPILE_STATUS))
            throw new Error(`could not compile fragment shader: ${gl.getShaderInfoLog(fragShader)}\n\n${source.trim()}`);
        return fragShader;
    }
    createProgram(vertShader, fragShader) {
        const gl = context_1.getWebGLContext();
        var program = gl.createProgram();
        if (!program)
            throw new Error("unable to create program");
        gl.attachShader(program, vertShader);
        gl.attachShader(program, fragShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS))
            throw new Error(`error in program linking: ${gl.getProgramInfoLog(program)}`);
        return program;
    }
    searchAndReplace(s, vars) {
        if (vars) {
            for (var [key, val] of Object.entries(vars)) {
                s = s.replace(key, val);
            }
        }
        return s;
    }
    getAttributeInfo(gl, program) {
        const attributeInfo = {};
        const cnt = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
        for (let idx = 0; idx < cnt; idx++) {
            const activeInfo = gl.getActiveAttrib(program, idx);
            if (activeInfo === null)
                continue;
            const location = gl.getAttribLocation(program, activeInfo.name);
            if (location === null)
                continue;
            attributeInfo[activeInfo.name] = {
                size: activeInfo.size,
                type: activeInfo.type,
                location: location
            };
        }
        return attributeInfo;
    }
    getUniformInfo(gl, program) {
        const uniformInfo = {};
        const cnt = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for (let idx = 0; idx < cnt; idx++) {
            const activeInfo = gl.getActiveUniform(program, idx);
            if (activeInfo === null)
                continue;
            const location = gl.getUniformLocation(program, activeInfo.name);
            if (location === null)
                continue;
            uniformInfo[activeInfo.name] = {
                size: activeInfo.size,
                type: activeInfo.type,
                location: location
            };
        }
        return uniformInfo;
    }
}
exports.ComputeShader = ComputeShader;
//# sourceMappingURL=computeShader.js.map